<template>
  <div :class="classs">
    <slot></slot>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    type: {
      type: String,
      default: 'default',
    },
    plain: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classs() {
      let classStr = `status-tag status-tag--${this.type} status-tag--${this.size}`;
      if (this.plain) {
        classStr = `${classStr} status-tag--plain`;
      }
      return classStr;
    },
  },
};
</script>

<style lang="less" scoped>
.status-tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  line-height: 20px;
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 400;
  white-space: nowrap;

  &--medium {
    font-size: 22px;
    line-height: 22px;
    padding: 5px 9px;
  }

  &--large {
    font-size: 24px;
    line-height: 24px;
    padding: 8px 10px;
  }

  &:not(:last-child) {
    margin-right: 10px;
  }

  &--default {
    color: #666666;
    background-color: #f5f5f5;
    border: 1px solid #f5f5f5;
  }
  &--primary {
    color: #0078ff;
    background-color: #e5f1ff;
    border: 1px solid #e5f1ff;
  }
  &--success {
    color: #2ba63c;
    background-color: #e9f6eb;
    border: 1px solid #e9f6eb;
  }

  &--danger {
    color: #e84c3d;
    background-color: #ffedee;
    border: 1px solid #ffedee;
  }

  &--warning {
    color: #f39b13;
    background-color: #fef3e3;
    border: 1px solid #fef3e3;
  }

  &--dark {
    color: #fff;
    background-color: #6e86b1;
    border: 1px solid #6e86b1;
  }

  &--plain {
    background-color: #fff;
    border: 1px solid;
  }
}
</style>